var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03033 0.21967C1.73744 -0.0732232 1.26256 -0.0732232 0.96967 0.21967C0.676777 0.512563 0.676777 0.987437 0.96967 1.28033L2.03033 0.21967ZM6 5.25L5.46967 5.78033C5.76256 6.07322 6.23744 6.07322 6.53033 5.78033L6 5.25ZM11.0303 1.28033C11.3232 0.987437 11.3232 0.512563 11.0303 0.21967C10.7374 -0.0732232 10.2626 -0.0732232 9.96967 0.21967L11.0303 1.28033ZM0.96967 1.28033L5.46967 5.78033L6.53033 4.71967L2.03033 0.21967L0.96967 1.28033ZM6.53033 5.78033L11.0303 1.28033L9.96967 0.21967L5.46967 4.71967L6.53033 5.78033Z",
    fill: "#767C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/iconDown.9180629e330629dbf6e98b794cca0ed1.svg";
export { ForwardRef as ReactComponent };